module.exports = __webpack_public_path__ + "img/milelogix_gold_black.29c1db38.png";